// Base javascript for login and user account management.

require("@rails/ujs").start()
require("@rails/activestorage").start()

try {
  window.$ = window.jQuery = require('jquery');
} catch (e) {}
require('mdb-ui-kit');
